<template>
  <el-button
    class="action-btn btn-green rounded fa-sm ml-1"
    size="small"
    plain
    :class="
      initial_purchase.invoice_collections.length == 0
        ? 'btn-plain-grey'
        : 'btn-secondary'
    "
    style="width: 30px"
    @click="downloadDocument()"
    v-if="show_item == false"
  >
    INV
  </el-button>
  <el-dropdown-item @click.native="downloadDocument()" v-else>
    INV
  </el-dropdown-item>
</template>
<script>
export default {
  props: {
    initial_purchase: {
      type: Object,
    },
    show_item: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {
    downloadDocument() {
      let media = this.initial_purchase.invoice_collections;
      if (media[0]) {
        var anchor = document.createElement("a");
        anchor.href = media[0].url;
        anchor.target = "_blank";
        anchor.download = media[0].file_name;
        anchor.click();
      }
    },
  },
};
</script>
